import React, { useState, useRef } from 'react';
import PartnerCarousel from './partnerCarousel';
import Footer from './footer';
import Header from './header';
import { useNavigate } from 'react-router-dom';

const About = () => {

    const navigate = useNavigate();

    const handleNavigate = (path: string, id?: string) => {
        navigate(path);
        if (id) {
            setTimeout(() => {
                const element = document.getElementById(id);
                if (element) element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    };

    return (
        <div className="flex flex-col w-[100%] h-[100%]">
            <div className='felx flex-col lg:h-screen min-h-screen bg-gradient-to-br from-[#001F40] to-[#08427B]'>
                <div id='inicio' className='pt-5 pl-3 h-[10%] lg:h-[20%] lg:flex lg:items-center'>
                    <Header />
                </div>
                <div className=' flex flex-col items-center md:flex-row md:p-3 h-[90%] lg:h-[80%] lg:justify-evenly lg:w-[100%]'>
                    <div className='text-white flex flex-col w-[85%] mt-3 mb-3 md:w-[50%] md:p-3 lg:w-[45%] lg:p-6'>
                        <h1 className='text-2xl md:text-4xl lg:text-5xl'>
                            Quem somos?
                        </h1>
                        <p className='flex mt-5 mb-2 md:text-xl lg:mt-10 lg:text-2xl'>
                            Somos uma contabilidade 100% online, focada em oferecer soluções práticas para MEIs, microempresas e empreendedores que buscam mais facilidade na gestão financeira.
                        </p>
                        <p className='flex mt-5 mb-5 md:text-xl lg:mt-3 lg:mb-10 lg:text-2xl'>
                            Com tecnologia, transparência e um atendimento especializado, ajudamos você a manter
                            seu negócio regularizado, economizar tempo e focar no que realmente importa: o
                            crescimento da sua empresa. Aqui, sua contabilidade está nas mãos certas!
                        </p>
                        <button onClick={() => window.open('https://wa.me/5512987047332?text=Olá, gostaria de saber mais sobre a MainCode!', '_blank')} className='border border-1px border-maincodeDarkBlue p-3 rounded-lg lg:w-[50%] w-[75%] flex items-center justify-evenly'>Entre em contato conosco</button>
                    </div>
                    <div className='flex mt-3 mb-3 md:w-[50%] lg:w-[40%] lg:mb-0'>
                        <img src="success_parcelex_1.svg" alt="image-1" className='lg:h-[100%]' />
                    </div>
                </div>
            </div>
            <div className='flex flex-col items-center w-[100%] h-[100%]'>
                <div className='text-[#000000] bg-[white] flex flex-col w-[100%] p-6 lg:h-[33%] lg:pl-20 dark:bg-maincodeSecondBlueDark dark:text-white '>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        Descomplicando a sua contabilidade
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        A Declarei Digital foi criada com o propósito de simplificar a gestão do seu negócio,
                        oferecendo serviços totalmente digitais, ágeis, transparentes e livres de burocracia
                    </p>
                </div>
                <div className='text-[#000000] bg-[#0f7022b5] flex flex-col w-[100%] p-6 lg:h-[33%] lg:pl-20 dark:bg-[#5da0c491]  dark:text-white'>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        Há mais de 2 anos transformando sonhos em grandes negócios
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        Auxiliamos empreendedores que estão iniciando do zero ou que buscam suporte para
                        impulsionar o crescimento de seus negócios
                    </p>
                </div>
                <div className='text-[#000000] bg-[#0F7022] flex flex-col w-[100%] p-6 lg:pl-20 dark:bg-maincodeDarkBlueDark dark:text-white '>
                    <h1 className='text-2xl lg:text-4xl lg:mt-5'>
                        O controle financeiro ideal para sua empresa
                    </h1>
                    <p className='flex mt-3 mb-3 lg:text-2xl lg:mb-5'>
                        Otimizamos seu tempo e impulsionamos sua receita com um controle personalizado e
                        eficiente
                    </p>
                </div>
            </div>
            <div className='flex flex-col p-3 h-[100%] w-[100%] dark:bg-[#5da0c4e1] dark:text-white'>
                <div className='text-maincodeDarkBlue dark:text-white flex w-[100%] justify-center items-center lg:text-4xl text-2xl mb-3 lg:mb-5 lg:mt-3'>
                    <h2>Quem confia no nosso trabalho</h2>
                </div>
                <div className='lg:mb-5'>
                    <PartnerCarousel />
                </div>
            </div>
            <div className='flex w-[100%] h-[100%]'>
                <Footer />
            </div>
        </div>
    );
};

export default About;